import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M22.1352 6.66797H25.4065L18.2597 14.8362L26.6673 25.9513H20.0843L14.9283 19.2101L9.02848 25.9513H5.75525L13.3993 17.2145L5.33398 6.66797H12.0841L16.7448 12.8297L22.1352 6.66797ZM20.9872 23.9933H22.7997L11.0992 8.52313H9.15406L20.9872 23.9933Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }